// Theme: legacy-mode
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'legacy-mode',
  name: 'LEGACY MODE',
  tagline: 'LEGACY MODE',
  description: 'Edicao historica premium com assinatura rosa legado intensa.',
  category: 'alternate-modes',
  tier: 'legendary',
  basePrice: 5250,
  swatches: ['#12090D', '#E879A0', '#201018', '#FFE3F0'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 12%, transparent)'
    },
    shellClasses: 'font-serif theme-legacy-mode'
  },
  colorVars: {
    '--accent': '#E879A0',
    '--accent-foreground': '#12090D',
    '--background': '#12090D',
    '--border': '#7A2246',
    '--card': '#201018',
    '--card-border-active': 'rgba(232, 121, 160, 0.56)',
    '--card-completed': '#201018',
    '--card-foreground': '#FFE3F0',
    '--card-glow': 'rgba(232, 121, 160, 0.12)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#12090D',
    '--foreground': '#FFE3F0',
    '--hold-fill': '#E879A0',
    '--input': '#201018',
    '--modal-bg': '#12090D',
    '--modal-border': '#7A2246',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#7A2246',
    '--muted-foreground': '#FFE3F0',
    '--nav-active': '#E879A0',
    '--nav-bg': '#12090D',
    '--popover': '#201018',
    '--popover-foreground': '#FFE3F0',
    '--primary': '#E879A0',
    '--primary-foreground': '#12090D',
    '--ring': '#E879A0',
    '--secondary': '#7A2246',
    '--secondary-foreground': '#FFE3F0',
    '--streak': '#E879A0',
    '--success': '#22C55E',
    '--success-foreground': '#12090D',
    '--xp': '#E879A0',
    '--xp-bg': '#201018'
  },
  resolvedVars: {
    '--accent': '#E879A0',
    '--accent-foreground': '#12090D',
    '--accent-foreground-hsl': '333 33% 5%',
    '--accent-foreground-oklch': 'from #12090D l c h',
    '--accent-hsl': '339 71% 69%',
    '--accent-oklch': 'from #E879A0 l c h',
    '--background': '#12090D',
    '--background-hsl': '333 33% 5%',
    '--background-oklch': 'from #12090D l c h',
    '--border': '#7A2246',
    '--border-hsl': '335 56% 31%',
    '--border-oklch': 'from #7A2246 l c h',
    '--border-w': '1px',
    '--card': '#201018',
    '--card-border-active': 'rgba(232, 121, 160, 0.56)',
    '--card-completed': '#201018',
    '--card-completed-hsl': '330 33% 9%',
    '--card-completed-oklch': 'from #201018 l c h',
    '--card-foreground': '#FFE3F0',
    '--card-foreground-hsl': '332 100% 95%',
    '--card-foreground-oklch': 'from #FFE3F0 l c h',
    '--card-glow': 'rgba(232, 121, 160, 0.12)',
    '--card-hsl': '330 33% 9%',
    '--card-oklch': 'from #201018 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#12090D',
    '--destructive-foreground-hsl': '333 33% 5%',
    '--destructive-foreground-oklch': 'from #12090D l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#FFE3F0',
    '--foreground-hsl': '332 100% 95%',
    '--foreground-oklch': 'from #FFE3F0 l c h',
    '--hold-fill': '#E879A0',
    '--hold-fill-hsl': '339 71% 69%',
    '--hold-fill-oklch': 'from #E879A0 l c h',
    '--input': '#201018',
    '--input-hsl': '330 33% 9%',
    '--input-oklch': 'from #201018 l c h',
    '--modal-bg': '#12090D',
    '--modal-bg-hsl': '333 33% 5%',
    '--modal-bg-oklch': 'from #12090D l c h',
    '--modal-border': '#7A2246',
    '--modal-border-hsl': '335 56% 31%',
    '--modal-border-oklch': 'from #7A2246 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#7A2246',
    '--muted-foreground': '#FFE3F0',
    '--muted-foreground-hsl': '332 100% 95%',
    '--muted-foreground-oklch': 'from #FFE3F0 l c h',
    '--muted-hsl': '335 56% 31%',
    '--muted-oklch': 'from #7A2246 l c h',
    '--nav-active': '#E879A0',
    '--nav-active-hsl': '339 71% 69%',
    '--nav-active-oklch': 'from #E879A0 l c h',
    '--nav-bg': '#12090D',
    '--nav-bg-hsl': '333 33% 5%',
    '--nav-bg-oklch': 'from #12090D l c h',
    '--popover': '#201018',
    '--popover-foreground': '#FFE3F0',
    '--popover-foreground-hsl': '332 100% 95%',
    '--popover-foreground-oklch': 'from #FFE3F0 l c h',
    '--popover-hsl': '330 33% 9%',
    '--popover-oklch': 'from #201018 l c h',
    '--primary': '#E879A0',
    '--primary-foreground': '#12090D',
    '--primary-foreground-hsl': '333 33% 5%',
    '--primary-foreground-oklch': 'from #12090D l c h',
    '--primary-hsl': '339 71% 69%',
    '--primary-oklch': 'from #E879A0 l c h',
    '--radius': '14px',
    '--ring': '#E879A0',
    '--ring-hsl': '339 71% 69%',
    '--ring-oklch': 'from #E879A0 l c h',
    '--secondary': '#7A2246',
    '--secondary-foreground': '#FFE3F0',
    '--secondary-foreground-hsl': '332 100% 95%',
    '--secondary-foreground-oklch': 'from #FFE3F0 l c h',
    '--secondary-hsl': '335 56% 31%',
    '--secondary-oklch': 'from #7A2246 l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 12%, transparent)',
    '--streak': '#E879A0',
    '--streak-hsl': '339 71% 69%',
    '--streak-oklch': 'from #E879A0 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#12090D',
    '--success-foreground-hsl': '333 33% 5%',
    '--success-foreground-oklch': 'from #12090D l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(339 71% 69% / 0.15)',
    '--xp': '#E879A0',
    '--xp-bg': '#201018',
    '--xp-bg-hsl': '330 33% 9%',
    '--xp-bg-oklch': 'from #201018 l c h',
    '--xp-hsl': '339 71% 69%',
    '--xp-oklch': 'from #E879A0 l c h'
  }
}
